<app-card-table
    #sharesTable
    [gridData]="store.data.getServiceDataShares()"
    [refreshCallback]="store.api.getServiceDataShares"
    [columns]="columns"
    [tableTitle]="'service.dataShare.title'"
    [additionalFilter]="[[{ column: 'serviceId', operator: 'EQ', value: [store.serviceId()] }]]"
    translatePrefix="service.dataShare."
    [hideCheckboxes]="true"
    (detailCallback)="detail($event)"
    (createCallback)="detail($event)"
    (deleteCallbackWithEvent)="delete($event)"
>
    <ng-template pTemplate="employmentNames" let-data="data">
        <div class="items-list">
            @for (name of data; track $index) {
                <div>
                    {{ 'user.common.employmentTypes.' + name | translate }}
                    @if ($index < data.length - 1) {
                        <span>,&nbsp;</span>
                    }
                </div>
            }
        </div>
    </ng-template>
    <ng-template pTemplate="widgets" let-data="data">
        <div class="items-list">
            @for (name of data; track $index) {
                <div>
                    {{ 'enum.folderDashboardWidgets.' + name | translate }}
                    @if ($index < data.length - 1) {
                        <span>,&nbsp;</span>
                    }
                </div>
            }
        </div>
    </ng-template>
</app-card-table>
